import { memo } from "react";
import { Link } from "react-router-dom";
import { Sparkles, BadgePercent } from "lucide-react";

const PERKS = [
  "Earn a point every $1 you spend",
  "Free birthday drink (yes, any size)",
  "First dibs on seasonal drops",
];

function RewardsCTA() {
  return (
    <section
      data-testid="home-rewards-cta"
      className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16"
    >
      <div
        className="relative overflow-hidden rounded-3xl border border-white/10 p-6 sm:p-10 lg:p-14"
        style={{
          background:
            "radial-gradient(900px circle at 10% 20%, hsla(252,90%,72%,0.9), transparent 55%)," +
            "radial-gradient(800px circle at 90% 80%, hsla(330,90%,72%,0.9), transparent 55%)," +
            "linear-gradient(135deg, hsl(252 63% 48%), hsl(330 78% 58%))",
          color: "white",
          boxShadow: "0 40px 120px -50px rgba(91,63,209,0.6)",
        }}
      >
        <span aria-hidden="true" className="absolute top-5 right-10 w-10 h-10 rounded-full bg-white/25 blur-sm" />
        <span aria-hidden="true" className="absolute bottom-8 left-14 w-6 h-6 rounded-full bg-white/30" />
        <span aria-hidden="true" className="absolute top-1/2 right-24 w-4 h-4 rounded-full bg-white/35" />

        <div className="relative grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.18em] opacity-80">Boba Rewards</p>
            <h2 className="font-brand font-semibold text-[2rem] sm:text-4xl lg:text-5xl leading-[1.02] mt-2">
              50 points just for signing up.
            </h2>
            <p className="mt-3 opacity-90 max-w-xl text-[15px] sm:text-base">
              Join Boba Rewards and every sip adds up. Free drinks, birthday treats, and early looks at new flavors — on us.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/signup"
                data-testid="home-rewards-join-button"
                className="bg-white text-primary rounded-xl px-6 py-3 font-semibold shadow-lg hover:brightness-95 inline-flex items-center gap-2"
              >
                <BadgePercent className="w-4 h-4" /> Join Rewards
              </Link>
              <Link
                to="/login?as=customer"
                className="inline-flex items-center gap-2 rounded-xl border border-white/30 bg-white/10 hover:bg-white/15 text-white px-5 py-3 font-medium backdrop-blur"
                data-testid="home-rewards-login-button"
              >
                I'm already a member
              </Link>
            </div>
          </div>
          <ul className="lg:col-span-5 space-y-3">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-white/20 border border-white/30 grid place-items-center shrink-0 mt-0.5">
                  <Sparkles className="w-3 h-3" />
                </span>
                <span className="text-[15px] sm:text-base opacity-95">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default memo(RewardsCTA);
